import { FileUploader } from 'react-drag-drop-files'
import { primary_color } from '../../../../../Helper/uiHelper'

const fileTypes = ['JPG', 'JPEG', 'PNG']
const TicketFileUpload = ({ setBase64File, setFile, file }) => {
  const handleChange = (uploadedFile) => {
    const reader = new FileReader()
    reader.onload = () => {
      setBase64File(reader.result)
      setFile(uploadedFile)
    }
    reader.readAsDataURL(uploadedFile)
  }

  return (
    <div>
      {file ? (
        <div
          className='p-4 m-2 subtitle1 d-flex justify-content-center align-items-center position-relative'
          style={{ border: `1px dashed ${primary_color}`, borderRadius: '0.3rem', color: primary_color }}>
          {file?.name}
          <div
            className='position-absolute bg-danger py-1 px-2 d-flex justify-content-center align-items-center cursor-pointer'
            style={{ right: '-0.5rem', top: '-0.8rem', borderRadius: '100%', width: '1.5rem', height: '1.5rem' }}
            onClick={() => {
              setFile()
              setBase64File()
            }}>
            <i class='fa-solid fa-xmark subtitle1'></i>
          </div>
        </div>
      ) : (
        <FileUploader handleChange={handleChange} name='file' types={fileTypes} multiple={false} fileOrFiles={file} classes='file-upload-field' />
      )}
    </div>
  )
}

export default TicketFileUpload
